import { useSyncExternalStore } from 'react'
import { useFeatureFlagEnabled } from 'posthog-js/react'

import { getImpersonation, subscribeImpersonation } from '@/lib/impersonation'

// Kill switch: defaults OFF (fail-closed). The backend refuses starts while the flag is off, so
// `undefined` (still loading / flag absent) hides the action too. Staff viewing as an admin are
// refused on both routes, so the action and its status stay hidden for them.
export function useAdminNotetakerErasureEnabled(): boolean {
  const flag = useFeatureFlagEnabled('enterprise-admin-notetaker-erasure')
  const isImpersonating = useSyncExternalStore(subscribeImpersonation, getImpersonation) !== null
  return flag === true && !isImpersonating
}
